import { render } from "./TheDiTichDiSan.vue?vue&type=template&id=23d25b4e"
import script from "./TheDiTichDiSan.vue?vue&type=script&lang=js"
export * from "./TheDiTichDiSan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__